/*
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-03-29 12:42:54
 * @LastEditors: wangcan
 * @LastEditTime: 2023-03-30 11:06:24
 */

import httpRequest from '@/utils/httpRequest'

//登录
function login(data) {
    return httpRequest({
        url: `/sys/api/login`,
        method: 'post',
        data
    })
}
//根据id获取双选会详情
function meetingInfo(id) {
    return httpRequest({
        url: `/api/meeting/meetingInfo/${id}`,
        method: 'get'
    })
}


//根据id获取双选会报名企业列表
function meetingCompanyList(params) {
    return httpRequest({
        url: '/api/meeting/meetingCompanyList',
        method: 'get',
        params
    })
}
//根据ID获取双选会报名企业详情信息
function getMeetingCompanyInfo(id) {
    return httpRequest({
        url: `/api/meeting/getMeetingCompanyInfo/${id}`,
        method: 'get'
    })
}

//获取全部学院列表
function schoolList() {
    return httpRequest({
        url: `/api/meeting/schoolList`,
        method: 'get'
    })
}
//根据学院id获取全部班级列表
function classList(id) {
    return httpRequest({
        url: `/api/meeting/classList/${id}`,
        method: 'get'
    })
}
//保存简历
function saveResume(data) {
    return httpRequest({
        url: `/api/meeting/saveResume`,
        method: 'post',
        data
    })
}
//上传简历
function uploadResume(data) {
    return httpRequest({
        url: `/api/meeting/upload`,
        method: 'post',
        data,
        headers: {
            //添加请求头
            "Content-Type": "multipart/form-data"
          }
    })
}
//oss获取配置
function ossPolicy() {
    return httpRequest({
        url: `/api/meeting/oss/policy`,
        method: 'get'
    })
}
//oss请求
function ossUpload(urlPath,data) {
    return httpRequest({
        url: urlPath,
        method: 'post',
        cache: false,
        contentType: false,
        processData: false,
        data
    })
}
export { login,meetingInfo,meetingCompanyList,getMeetingCompanyInfo,schoolList,classList,saveResume,uploadResume,ossPolicy,ossUpload}